import { DemoButton } from '@web/components/DemoButton'
import ProductName from '@web/components/ProductName'

type Stat = {
  stat: React.ReactNode
  label: string
}

const stats: Stat[] = [
  {
    stat: (
      <>
        45 min<span className="text-brand-cyan"> → </span>&lt;5 min
      </>
    ),
    label: 'Hazard-section drafting time per LIM',
  },
  {
    stat: (
      <>
        50<span className="text-brand-cyan"> to </span>90
        <span className="text-brand-cyan">%</span>
      </>
    ),
    label: 'Reduction in LIM hazard-section processing time',
  },
  {
    stat: (
      <>
        50<span className="text-brand-cyan"> to </span>70
        <span className="text-brand-cyan">%</span>
      </>
    ),
    label: 'Reduction in external hazards consulting spend on screening-level assessments',
  },
  {
    stat: (
      <>
        2<span className="text-brand-cyan"> to </span>8 months
      </>
    ),
    label: 'Typical payback on the annual licence',
  },
]

const ProofPoint = () => {
  return (
    <section className="bg-brand-navy py-24 sm:py-16">
      <div className="mx-auto max-w-5xl px-6 lg:px-8 space-y-12">
        <div className="space-y-6">
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-cyan">
            What we typically see across deployments
          </span>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="space-y-2">
                <p className="text-3xl font-light text-white leading-none m-0 tabular-nums">
                  {s.stat}
                </p>
                <p className="text-sm text-white/70 leading-relaxed m-0">{s.label}</p>
              </div>
            ))}
          </div>
          <p className="text-xs text-white/55 leading-relaxed m-0 max-w-3xl italic">
            These figures are Urban Intelligence&apos;s generalisations across observed deployments,
            including Hamilton City Council. They are not Hamilton&apos;s verbatim claims and
            specific results vary by council size and current process baseline. <ProductName />{' '}
            delivers comparable outcomes when council data and workflows are in place.
          </p>
        </div>

        <div className="border-0 border-t border-solid border-white/15 pt-10 space-y-6">
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-cyan">
            Case study &middot; Hamilton City Council &middot; LIM workflow
          </span>
          <blockquote className="text-2xl font-light text-white leading-relaxed border-0 border-l-4 border-solid border-brand-cyan pl-6 m-0 italic max-w-4xl">
            &ldquo;Resilience Explorer offers an efficient solution for researching individual
            parcels. It generates a concise PDF document that integrates seamlessly into the
            existing LIM template, providing assurance that our reports are accurate and based on
            the most up-to-date information, thereby minimising the risk of human error.&rdquo;
          </blockquote>
          <p className="text-sm text-white/70 m-0">
            — Hamilton City Council, quoted directly. The quote refers to the LIM workflow.
          </p>
          <div>
            <DemoButton theme="light" label="Book a 20-minute walkthrough" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProofPoint
